'use client';

import { ErrorFallbackView } from '@/components/error-fallback-view';
import { QueryErrorResetBoundary } from '@tanstack/react-query';
import { useTranslations } from 'next-intl';
import type { ReactNode } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

export const GlobalErrorBoundary = ({ children }: { children: ReactNode }) => {
  const t = useTranslations('common.error.error_fallback_page');

  return (
    <QueryErrorResetBoundary>
      {({ reset }) => (
        <ErrorBoundary
          onReset={reset}
          fallbackRender={(props) => (
            <ErrorFallbackView
              {...props}
              message={t('message')}
              btnText={t('btn_reload')}
            />
          )}
        >
          {children}
        </ErrorBoundary>
      )}
    </QueryErrorResetBoundary>
  );
};
